import React from 'react'

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

interface Props extends SvgIconProps {
}

const iconPath = 'M18.856 18.636l.88-5.43a.365.365 0 0 0-.081-.295.353.353 0 0 0-.275-.125h-4.55l6' +
'.333-7.317-.88 5.431a.357.357 0 0 0 .356.418h4.55l-6.333 7.318zM39.959 8.07c.011.031.022.06.028.0' +
'93.011.055.016.11.011.183a.693.693 0 0 1-.013.152c-.006.042-.022.08-.035.119a.135.135 0 0 1-.01.0' +
'4.824.824 0 0 1-.08.145.738.738 0 0 1-.104.13l-3.628 3.664a.834.834 0 0 1-1.188 0 .853.853 0 0 1 ' +
'0-1.197l2.2-2.222h-6.924a.846.846 0 0 1-.8-.582c-1.338-4.127-5.125-6.9-9.423-6.9-4.295 0-8.084 2.' +
'773-9.423 6.9a.84.84 0 0 1-1.062.54.852.852 0 0 1-.535-1.07C10.542 3.24 14.971 0 19.993 0c4.818 0' +
' 9.09 2.982 10.813 7.482h6.334l-2.197-2.221a.853.853 0 0 1 0-1.198.832.832 0 0 1 1.186 0l3.651 3.' +
'693c.029.033.057.066.081.101.013.018.018.036.029.053.017.031.037.06.05.093.009.022.013.044.02.066' +
'zm-10.528 7.337a.838.838 0 0 1 1.06-.54c.44.145.678.624.537 1.07C29.459 20.76 25.03 24 20.008 24c' +
'-4.818 0-9.09-2.982-10.813-7.482H2.86l2.201 2.217a.853.853 0 0 1 0 1.197.834.834 0 0 1-1.188 0l-3' +
'.63-3.666A.862.862 0 0 1 0 15.668a.878.878 0 0 1 .248-.6l3.627-3.664a.832.832 0 0 1 1.186 0 .853.' +
'853 0 0 1 0 1.198l-2.199 2.222h6.923c.363 0 .684.236.8.582 1.338 4.127 5.125 6.9 9.423 6.9 4.296 ' +
'0 8.085-2.773 9.424-6.9z'

const AutoSubIcon: React.SFC<Props> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d={iconPath} />
    </SvgIcon>
  )
}

AutoSubIcon.defaultProps = {
  viewBox: '0 0 40 24',
}

export default AutoSubIcon
